export default function pluralize(value, count) {
  if (!value) return ''
  return count !== 1 ? value.replace(/\(|\)/g, '') : value.replace(/\(s\)/g, '')
}
